<template>
  <div>
    <div class="box box-primary" style="width:100%">
      <div class="box-header with-border">
        <div
          style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
        >
          <b>{{ $t("sidebar.contract.apartmentcontractlist") }}</b>
          <lte-button
            style="float:right;"
            type="btn
                btn-primary"
            right_icon="fa
                fa-plus"
            v-if="
              GET_ACCOUNT_DATA.id == 1 || has_perm('create_apartment_contract')
            "
            @click="handleAdd($event)"
            >{{ $t("common.add") }}</lte-button
          >
          <lte-button
            style="float:right;background-color:white;margin-left: 1rem; margin-right: 1rem; !important;"
            type="btn btn-default"
            right_icon="fa fa-upload"
            v-if="
              GET_ACCOUNT_DATA.id == 1 || has_perm('import_apartment_contract')
            "
            @click="importExcel"
            >{{ $t("sidebar.decentralizationManagement.import") }}</lte-button
          >
        </div>
        <select-option-check
          style="margin-top:-40px"
          :item="columnsContract"
          class="dropdown-trigger"
          data-icon="eye"
          @callbackData="onColumnSelect"
        ></select-option-check>
      </div>
      <div class="box-body">
        <lte-table
          ref="lte_table"
          :hdBackground="hdBackground"
          :data="contract_list"
          :columns="gridColumns"
          search_filter="left-search"
          @actions="crudActions"
          :useFilter="useFilter"
          :actions="
            GET_ACCOUNT_DATA.id == 1 ||
            (has_perm('update_apartment_contract') &&
              has_perm('delete_apartment_contract'))
              ? actions
              : has_perm('update_apartment_contract')
              ? [actions[0]]
              : has_perm('delete_apartment_contract')
              ? [actions[1]]
              : []
          "
          :row_mouse_pointer="false"
          :boxStyle="boxStyle"
        ></lte-table>
      </div>
      <!-- Pagination -->
      <div class="box-footer clearfix" style="display:contents;">
        <paginator :item="paginatorItem" @onpaginate="onPagination" />
      </div>
    </div>
    <div class="modal fade" :ref="`modal-delete`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("contract.delete_confirm.title") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row mb-1 margin-down-15">
              <div class="col-md-6 col-sm-6">
                <span>{{ $t("contract.delete_confirm.comment_head") }}</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="closeModalDelete()"
              class="btn btn-warning pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              @click="deleteContract()"
              class="btn btn-primary"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTETable from "@/components/LTETable.vue";
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
import LTEButton from "@/components/LTEButton.vue";
import utils from '@/lib/utils';
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import Paginator from "@/components/Paginator.vue";

export default {
  name: "ApartmentContractList",
  data() {
    return {
      useFilter: false,
      boxStyle: true,
      paginatorItem: {
        commit_function: "GET_CONTRACT_LIST"
      },
      columnsContract: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      actions: ["common.modify", "common.delete"],
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;",
      contract_list: [],
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "contract.contract_no", isHidden: true },
        { text: "contract.sign_date", isHidden: true },
        { text: "contract.status", isHidden: true },
        { text: "contract.deposit", isHidden: true }
      ],
      contract_id: null,
      isLoading: false
    };
  },
  watch: {
    GET_CONTRACT_DATA: function() {
      this.contract_list = [];
      this.GET_CONTRACT_DATA.forEach((contract, idx) => {
        let id = contract.id;
        let date_sign = utils.formatSqlDate(contract.date_signed, null, "DD/MM/YYYY");
        let data = {
          id: id,
          "common.nonumber": idx + 1,
          "contract.contract_no": contract.contract_no,
          "contract.sign_date": date_sign,
          "contract.status": this.getContractStatusName(contract.status),
          "contract.deposit": utils.convertFormatNumberToMoney(contract.deposit)
        };
        this.contract_list.push(data);
      });
      this.isLoading = false;
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
        const viewedColumnsKey = Object.keys(
          this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
        );
        const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
          .viewed_columns;
        let newGridColumns = [];
        if (this.gridColumns.length == viewedColumns.length) {
          for (
            let j = 0, sizeOrigin = this.gridColumns.length;
            j < sizeOrigin;
            j++
          ) {
            for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
              if (this.gridColumns[j].text == viewedColumnsKey[i]) {
                let viewdColumnObject = {};
                viewdColumnObject.text = viewedColumnsKey[i];
                viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
                newGridColumns.push(viewdColumnObject);
                break;
              }
            }
          }
          this.gridColumns = newGridColumns;
          this.columnsContract.data_list = this.gridColumns;
        }
        // update when add columns in table
        else if (this.gridColumns.length != viewedColumnsKey.length) {
          let updateGridColumns = [];
          for (let i = 0; i < this.gridColumns.length; i++) {
            for (let j = 0; j < viewedColumnsKey.length; j++) {
              if (this.gridColumns[i] != viewedColumnsKey[j]) {
                let viewdColumnObject = {};
                viewdColumnObject.text = this.gridColumns[i].text;
                viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[j]];
                updateGridColumns.push(viewdColumnObject);
                break;
              }
            }
          }
          this.gridColumns = updateGridColumns;
          this.columnsContract.data_list = this.gridColumns;
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "PAGINATOR",
      "PAGE_ARROW",
      "PAGINATION",
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA",
      "GET_LANG",
      "GET_CONTRACT_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "ON_SHOW_TOAST",
      "DELETE_CONTRACT",
      "GET_CONTRACT_LIST"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    handleAdd: function() {
      this.$router.push({
        name: "ApartmentContractAdd",
        params: {
          id: 0
        }
      });
    },
    getContractStatusName: function(status) {
      return this.$t(utils.getContractStatusName(status))
    },
    crudActions: function(recordData, actionsType) {
      if (actionsType == LTEActionTypeEnum.MODIFY) {
        if (
          this.GET_ACCOUNT_DATA.id == 1 ||
          this.has_perm("create_apartment_contract")
        ) {
          this.$router.push({
            name: "ApartmentContractAdd",
            params: {
              id: recordData.id
            }
          });
        } else {
          this.ON_SHOW_TOAST({
            message: this.$t("contract.not_permission"),
            styleType: "danger"
          });
        }
      } else {
        if (
          this.GET_ACCOUNT_DATA.id == 1 ||
          this.has_perm("delete_apartment_contract")
        ) {
          this.contract_id = recordData.id;
          $(this.$refs[`modal-delete`]).modal("show");
        } else {
          this.ON_SHOW_TOAST({
            message: this.$t("contract.not_permission"),
            styleType: "danger"
          });
        }
      }
    },
    deleteContract: function() {
      let id = this.contract_id;
      let data = {
        id: id
      };
      this.isLoading = true;
      this.DELETE_CONTRACT(data)
        .then(
          function() {
            this.SUCCESS_TOAST();
            const data = {
              params: {
                page: 1
              }
            };
            this.GET_CONTRACT_LIST(data);
            $(this.$refs[`modal-delete`]).modal("hide");
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            $(this.$refs[`modal-delete`]).modal("hide");
            this.isLoading = false;
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    closeModalDelete: function() {
      $(this.$refs[`modal-delete`]).modal("hide");
    },
    onColumnSelect: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "apartmentscontractlist";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(function() {}.bind(this))
        .catch(function() {}.bind(this));
    },

    onPagination: function(data) {
      this.GET_CONTRACT_LIST(data);
    },
    importExcel: function() {
      this.$router.push({
        name: "ApartmentContractImportExcel",
        params: {
          id: 0
        }
      });
    }
  },
  mounted() {
    const data = {
      params: {
        page: 1
      }
    };
    // this.isLoading = true;
    this.GET_CONTRACT_LIST(data);
    this.columnsContract.data_list = this.gridColumns;
    const filter = {
      params: {
        tablename: "apartmentscontractlist"
      }
    };
    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
  },
  components: {
    "lte-button": LTEButton,
    "select-option-check": SelectOptionCheck,
    "lte-table": LTETable,
    paginator: Paginator,
    "lte-core-alert": LTECoreAlert,
    loading: Loading
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentContractList.vue